import {
  CHANGE_MENU_ADD,
  CHANGE_MENU_REMOVE,
  CHANGE_RANGE
} from '../actions/menu';
const initialState = {
  range: 50,
  mealMenu: []
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case CHANGE_MENU_ADD:
      return {
        ...state,
        mealMenu: [...state.mealMenu, payload]
      };
    case CHANGE_MENU_REMOVE:
      return {
        ...state,
        mealMenu: state.mealMenu.filter(meal => meal !== payload)
      };
    case CHANGE_RANGE:
      return {
        ...state,
        range: parseInt(payload)
      };
    default:
      return state;
  }
};
